import axios from 'axios';
import {
  SET_TIPO_DOCUMENTO,
  SET_LOADING
} from "../../constans/action-types";
import { URL, getAuthorizationHeader, getAuthorizationHeaderUpload } from '../../constans/constants';
import Cookies from 'universal-cookie';
import { logout } from '../login/SesionService';

const cookies = new Cookies();
const defaultPage = 0;
const defaultSize = 5;
export const setTiposDocumentos = payload => ({ type: SET_TIPO_DOCUMENTO, payload });
export const setLoading = payload => ({ type: SET_LOADING, payload });

export const getTipoTramite = (page = defaultPage, size = defaultSize, search) => {
  return dispatch => {
    var urlRequest = ""
    var idEmpresa = cookies.get('empresa');
    if ((search == null || search == '') && (idEmpresa == null || idEmpresa == undefined)) {
      urlRequest = URL + "tipoTramite/" + 'listar?page=' + page + "&size=" + size
    } else if ((search != null || search != '') && (idEmpresa == null || idEmpresa == undefined)) {
      urlRequest = URL + "tipoTramite/" + 'listar?page=' + page + "&size=" + size + "&search=" + search
    } else if ((search == null || search == '') && (idEmpresa != null)) {
      urlRequest = URL + "tipoTramite/" + 'listar?page=' + page + "&size=" + size + "&idEmpresa=" + idEmpresa
    } else if (search != null && idEmpresa != null) {
      urlRequest = URL + "tipoTramite/" + 'listar?page=' + page + "&size=" + size + "&search=" + search + "&idEmpresa=" + idEmpresa
    }
    return axios.get(urlRequest, getAuthorizationHeader())
      .then(res => {
        dispatch(setTiposDocumentos({
          page: res.data.page.pageable.pageNumber,
          totalCount: res.data.page.totalElements,
          tipoDocumento: res.data.page.content
        }));
      }, error => {
        if (error.response.status === 401) {
         logout();
        }
        return error;
      });
  };
};

export const obtenerTipoTramite = (id) => {
  return axios.get(
    URL + "tipoTramite/obtener/" + id,
    getAuthorizationHeader()
  )
    .then((res) => { return res.data}, error => {
      if (error.response.status === 401) {
       logout();
      }
      return error;
    });
}


export const setTipoTramite = (data) => {
  return axios
  .post(URL + "tipoTramite/crear", data, getAuthorizationHeader())
  .then((res) => {return res.data}, error => {
    if (error.response.status === 401) {
     logout();
    }
    return error;
  })
}

export const importarPlantilla = (plantilla, id) => {
  return axios.post(
    URL + "tipoTramite/importarPlantilla/" + id,
    plantilla,
    getAuthorizationHeaderUpload()
  ).then((res) => {return res.data}, error => {
    if (error.response.status === 401) {
     logout();
    }
    return error;
  })
}

export const modificarTipoTramite = (data) => {
  return axios
    .post(URL + "tipoTramite/modificar", data, getAuthorizationHeader())
    .then((res) => {return res.data}, error => {
      if (error.response.status === 401) {
       logout();
      }
      return error;
    })
    
}

export const activarTipoTramite = (id) =>{
  return axios
  .post(URL + "tipoTramite/activar/" + id, null, getAuthorizationHeader())
  .then((res) => {return res.data}, error => {
    if (error.response.status === 401) {
      logout();
    }
    return error;
  })
}

export const desactivarTipoTramite = (id) =>{
  return axios
  .delete(URL + "tipoTramite/eliminar/" + id, getAuthorizationHeader())
  .then((res) => {return res.data}, error => {
    if (error.response.status === 401) {
      logout();
    }
    return error;
  })

}

export const obtenerPlantilla = (fileUID) =>{
  return axios
  .get(URL + "tipoTramite/obtenerPlantilla/" + fileUID, getAuthorizationHeader())
  .then((res) => {return res.data}, error => {
    if (error.response.status === 401) {
      logout();
    }
    return error;
  })
}

export const listarTiposTramites = (idEmpresa) => {
  var idEmpresa = cookies.get('empresa');
  return axios
  .get(URL + "tipoTramite/listar/" + idEmpresa, getAuthorizationHeader())
  .then((res) => {return res.data}, error => {
    if (error.response.status === 401) {
      logout();
    }
    return error;
  })
}


export const obtenerTiposFormularios = () => {
  return axios
  .get(URL + "tipoTramite/formularios", getAuthorizationHeader())
  .then((res) => {return res.data}, error => {
    if (error.response.status === 401) {
      logout();
    }
    return error;
  })
}

export const obtenerAccionesColaborador = () => {
  return axios
  .get(URL + "tipoTramite/accionesColaborador", getAuthorizationHeader())
  .then((res) => {return res.data}, error => {
    if (error.response.status === 401) {
      logout();
    }
    return error;
  })
}
